import authAxios from 'src/modules/shared/axios/authAxios';

export default class PlanService {
  static async fetchCheckoutSessionId(plan) {
    const response = await authAxios.post(
      `/plan/stripe/checkout`,
      {
        plan,
      },
    );

    return response.data.id;
  }

  static async fetchPortalUrl() {
    const response = await authAxios.post(
      `/plan/stripe/portal`,
    );

    return response.data.url;
  }
}
